var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4313 21.5071L43.2438 5.31956C43.0403 5.09361 42.7901 4.91456 42.5106 4.79478C42.2311 4.67499 41.929 4.61734 41.625 4.62581H18.5C17.2745 4.62947 16.1002 5.11793 15.2337 5.98449C14.3671 6.85105 13.8787 8.02531 13.875 9.25081V64.7508C13.8787 65.9763 14.3671 67.1506 15.2337 68.0171C16.1002 68.8837 17.2745 69.3722 18.5 69.3758H55.5C56.7255 69.3722 57.8998 68.8837 58.7663 68.0171C59.6329 67.1506 60.1213 65.9763 60.125 64.7508V23.1258C60.1335 22.8219 60.0758 22.5197 59.956 22.2402C59.8363 21.9607 59.6572 21.7106 59.4313 21.5071ZM41.625 10.1758L54.575 23.1258H41.625V10.1758ZM55.5 64.7508H18.5V9.25081H37V23.1258C37.0037 24.3513 37.4921 25.5256 38.3587 26.3921C39.2252 27.2587 40.3995 27.7472 41.625 27.7508H55.5V64.7508Z",
    fill: "#CDCFFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.257b3e57bf9d9ed4e949879b5450ce52.svg";
export { ForwardRef as ReactComponent };